import React from "react";
import { StyleSheet, View } from "react-native";
import { colors } from "../../theme";
import Heading from "../../components/Heading";
import Text from "../../components/Text";

type Props = {
  title: string;
  description: string;
  renderFooter?: () => React.Component;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.darkestGrey,
    padding: 30,
    paddingHorizontal: 30,
    borderRadius: 20,
  },
  header: {
    textAlign: "center",
    color: colors.white,
    marginVertical: 10,
  },
  copy: {
    textAlign: "center",
    color: colors.midGrey,
  },
  footerContainer: {
    marginTop: 30,
  },
});

const EmptyCard: React.FC<Props> = ({ title, description, renderFooter }) => {
  return (
    <View style={styles.container}>
      <Heading size="l" style={styles.header}>
        {title}
      </Heading>
      <Text style={styles.copy}>{description}</Text>

      {renderFooter && (
        <View style={styles.footerContainer}>{renderFooter()}</View>
      )}
    </View>
  );
};

export default EmptyCard;
